module.exports = __webpack_public_path__ + "static/media/index_14.68231e8a.jpg";